import { AMAZON_AFFILIATE_TAG } from 'constants/vendor';
import { toUrl } from 'util/link';

export const HOSTNAME_REGEX = /(\w+\.)?(amazon|amzn)\.(com|ca|cn|de|es|fr|it|co\.uk|co\.jp|com\.br|to)$/;

/**
 * returns true if URL is affiliate link and false - if not
 *
 *
 * @export
 * @param {String} [url='']
 * @returns {Boolean} isAffiliate
 */
export function isAffiliateLink(url = '') {
  const parsedUrl = toUrl(url);

  return parsedUrl ? HOSTNAME_REGEX.test(parsedUrl.hostname) : false;
}

/**
 * returns props for affiliate link based on URL.
 *
 * object returned should at least have `href` prop.
 *
 * @export
 * @param {String} [url='']
 * @returns {Object} href
 */
export function getAffiliateLinkProps(url = '') {
  const parsedUrl = toUrl(url);
  const isAmazonUrl = isAffiliateLink(url);

  if (isAmazonUrl) {
    parsedUrl.searchParams.append('tag', AMAZON_AFFILIATE_TAG);
  }

  return isAmazonUrl
    ? {
        href: parsedUrl.toString(),
        target: '_blank',
        // NOTE, typically noopener and noreferrer should be used when opening
        // links in a new tab. However it is unclear if noreferrer violates
        // Amazon's terms of use.
        rel: 'nofollow'
      }
    : {
        href: url
      };
}

/**
 * adds amazon affiliate link tracking to applicable links.
 *
 * - updates link href to include tag in query param
 * - adds rel="nofollow" attr
 *
 * NOTE: impure function; operates on passed `tag`
 *
 * @param {HTMLElement} tag
 * @returns undefined (link is modified via reference)
 */
export function addAffiliateTrackingToHtmlTag(tag) {
  if (tag.tagName.toLowerCase() !== 'a') {
    return;
  }

  const attrs = getAffiliateLinkProps(tag.getAttribute('href'));

  Object.entries(attrs).forEach(([attr, value]) => {
    tag.setAttribute(attr, value);
  });
}
